import { f as flatMap_1 } from './flatMap-bcae5f36.js';
import { i as isEmpty_1 } from './isEmpty-b60327cb.js';

const findProductFeedMinimalPrice = (product) => {
  var _a;
  if (!product || !((_a = product === null || product === void 0 ? void 0 : product.RetailerProducts) === null || _a === void 0 ? void 0 : _a.length)) {
    return;
  }
  const stockPrices = flatMap_1(product.RetailerProducts, (retailerProduct) => retailerProduct === null || retailerProduct === void 0 ? void 0 : retailerProduct.StockPrices);
  const prices = stockPrices.map(({ Price }) => Price).filter(Boolean);
  if (!(prices === null || prices === void 0 ? void 0 : prices.length)) {
    return;
  }
  return Math.min(...prices);
};
const weeePricesToTextArray = (weeePrices) => {
  if (isEmpty_1(weeePrices)) {
    return [];
  }
  const { weeePriceLabel, weeeLamp, weeePro, weeePackage } = weeePrices !== null && weeePrices !== void 0 ? weeePrices : {};
  return [weeePriceLabel, weeeLamp, weeePro, weeePackage].filter(Boolean);
};
const applyPriceTemplate = (price, template, placeholder = '#PartnerPrice#') => template.replace(placeholder, price.toString());

export { applyPriceTemplate as a, findProductFeedMinimalPrice as f, weeePricesToTextArray as w };
